module.exports = __webpack_public_path__ + "img/诚信经营.37345790.jpg";